import React, { Component } from 'react';

import LibraryControlDetails from '../../views/control_library/library_control_details';
import { TagsAndOwnersViewComponent } from '../../views/control_library/control_library_components';

import 'semantic-ui-css/semantic.min.css';
import '../../App.css';

class LibraryControlItem extends Component {
  constructor(props){
    super(props);

    const control = props.control;
    const language = localStorage.getItem('language') || "English"
    const translation = control.translations && control.translations[language.toLowerCase()]
    
    if(translation) {
      control.title = translation.translation_result.title
      control.subtitle = translation.translation_result.subtitle
      control.description = translation.translation_result.description
    }

    this.state = {
      control: control,
      controlDetailsShown: false
    }
  }

  toggleCompleteDetails = () => {
    const { controlDetailsShown } = this.state;
    this.setState({ controlDetailsShown: !controlDetailsShown })
  }

  render() {
    const { controlDetailsShown, control } = this.state;
    const { deleteControl, index, showTranslationModal, showDeleteButton } = this.props;

    return (
      <div key={"control-" + control.id } className='control-details library-control-details'>
        <div>
          <span className='dynamic-custom-id link' onClick={this.toggleCompleteDetails}>{control.custom_id}</span>
          <span className='control-title'>{control.title}</span>
          <span> / </span>
          <span className='control-subtitle'>{control.subtitle}</span>
          <TagsAndOwnersViewComponent control={control} />
        </div>
        {
          controlDetailsShown &&
          <LibraryControlDetails control={control} hideLibControlDetails={this.toggleCompleteDetails} showTranslationModal={showTranslationModal}/>
        }
        {
          showDeleteButton &&
          <i className="delete icon delete-control"
            onClick={()=>deleteControl(index)}
            contentEditable="false"
            title="Delete this control">
          </i>
        }
      </div>
          
    );
  }
}

export default LibraryControlItem;


// WEBPACK FOOTER //
// ./src/components/controls_component/library_control_item.js